import React from 'react';
import SvgIcon from './SvgIcon';

const InsectInfestation = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M5.874 6.761a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM4.804 11.106c.525-1.126.342-2.323-.409-2.673-.75-.35-1.785.28-2.31 1.406-.525 1.126-.342 2.323.41 2.673.75.35 1.784-.28 2.31-1.406z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.818 8.527a1 1 0 100-2 1 1 0 000 2zM5.647 3.778l-.319-2.081.876-.695M7.155 4.482l1.799-1.095-.031-1.118M6.47 6.636s1.517.6 2.276-.436M5.724 7.95a2.617 2.617 0 002.477.6M4.985 9.118a1.955 1.955 0 002.37 1.247M4.446 5.716s-1.483-.826-1.18-2.07M3.868 7.085a2.616 2.616 0 01-2.054-1.51M3.5 8.421A2.027 2.027 0 01.97 7.388M18.733 6.737a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20.503 13.038c.808-.183 1.24-1.314.965-2.526-.276-1.212-1.153-2.046-1.961-1.862-.808.183-1.24 1.314-.965 2.526.275 1.212 1.153 2.045 1.96 1.862z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.286 8.675a1 1 0 100-2 1 1 0 000 2zM17.646 4.205l-1.528-1.451.267-1.086M19.267 3.837l.752-1.968-.709-.865M20.019 6.006s1.592-.506 1.559-1.786M20.261 7.454a2.618 2.618 0 002.328-1.041M20.394 8.83a1.954 1.954 0 002.637-.467M17.928 6.5s-1.724.226-2.247-.943M18.265 7.907a2.618 2.618 0 01-2.55.066M18.79 9.192a2.029 2.029 0 01-2.63.731M9.885 19.64a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5.3 21.92c1.127-.523 1.758-1.556 1.41-2.308-.349-.751-1.545-.937-2.673-.414-1.127.522-1.758 1.555-1.41 2.307.348.752 1.545.937 2.672.415z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.617 20.192a1 1 0 100-2 1 1 0 000 2zM10.667 16.861l1.098-1.797 1.118.033M11.385 18.373l2.063.32.697-.874M9.447 19.573s.783 1.436 2.028 1.137M8.037 20.1a2.618 2.618 0 001.506 2.058M6.72 20.517A1.954 1.954 0 007.728 23M8.547 17.465s-.648-1.485.385-2.242M7.176 18.242a2.618 2.618 0 01-.6-2.479M6.03 19.022A2.027 2.027 0 014.764 16.6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

InsectInfestation.displayName = 'InsectInfestationIcon';

export default InsectInfestation;
